import { takeLatest, call, select } from '@redux-saga/core/effects';
import queryString from 'query-string';
import Types from '../../types';
import { authenticateUserWithNoths } from '../../../services/AuthenticateService';
import { continueWithFacebookUrl } from '../../../utils';
import { getQueryParams } from '../../utils/selectors';
import { persist, getPersisted, removePersisted } from '../../utils/persist';
import { SUCCESSFUL_SIGN_IN_REDIRECT_KEY } from '../../../constants';

export function* signedInViaFacebook() {
  yield call(authenticateUserWithNoths);

  const redirectUrl = getPersisted(SUCCESSFUL_SIGN_IN_REDIRECT_KEY);
  if (redirectUrl) {
    removePersisted(SUCCESSFUL_SIGN_IN_REDIRECT_KEY);
    window.location.replace(redirectUrl);
  } else {
    window.location.replace('/');
  }
}

export function* continueWithFacebook() {
  const queryParams = yield select(getQueryParams);
  const redirectUrl = queryString.parse(queryParams).redirect_url;
  if (redirectUrl) {
    persist(SUCCESSFUL_SIGN_IN_REDIRECT_KEY, redirectUrl);
  }
  window.location.assign(continueWithFacebookUrl());
}

function* socialSaga() {
  yield takeLatest(Types.CONTINUE_WITH_FACEBOOK, continueWithFacebook);
  yield takeLatest(Types.SIGNED_IN_VIA_FACEBOOK, signedInViaFacebook);
}

export default socialSaga;
